module.exports = __webpack_public_path__ + "img/us-benefits-right.7f921e6e.png";